import { useContext } from 'react'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBorderOuter, faFileExport, faList, faLock, faPenToSquare, faToggleOff, faToggleOn,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { UseAgencyPayload } from '@hooks/useAgency'
import useCurrentUser from '@hooks/useCurrentUser'

import { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import useCopyAgencyData from '../../hooks/useCopyAgencyData'

type ConfirmLockParams = {
  toggleAgencyLock: (payload: HandleCallbackActionParams) => void,
  toggleFn: () => void,
}

const confirmLock = (params: ConfirmLockParams) => {
  const { toggleAgencyLock, toggleFn } = params

  const toggleAgencyLockPayload = {
    callbacks: {
      action: toggleFn,
    },
    toastText: 'Agency Locked',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, lock it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Lock Agency?',
    })
    .then(({ value }) => {
      if (value){
        // @ts-expect-error TS2345
        toggleAgencyLock(toggleAgencyLockPayload)
      }
    })
}

interface AgencyToolsProps {
  agencyPayload: UseAgencyPayload,
}

const AgencyTools = (props: AgencyToolsProps) => {
  const { agencyPayload } = props
  const {
    agency,
    callbacks: {
      copyAgencyData,
      exportAgency: exportFn,
      manageAgencyEnabledStatus,
      manageAgencyFeatures,
      manageAgencyOptions,
      manageAgencyTemplates,
      toggleAgencyLock: toggleFn,
    },
    isActive,
    loading,
  } = agencyPayload

  // @ts-expect-error TS2345
  useCopyAgencyData(agency)

  const pageContext = useContext(PageContext)
  const {
    callbacks: { exportAgency, toggleAgencyLock },
  } = pageContext

  const { isMasterAdmin } = useCurrentUser()

  const exportAgencyPayload = {
    callbacks: {
      action: exportFn,
    },
    toastText: 'Export Agency Queued',
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faPenToSquare} />}
        //@ts-expect-error
        marginBottom="medium"
        onClick={() => manageAgencyFeatures()}
        size="medium"
      >
        Agency Features
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faList} />}
        //@ts-expect-error
        marginBottom="medium"
        onClick={() => manageAgencyOptions()}
        size="medium"
      >
        Agency Options
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={isActive ? faToggleOff : faToggleOn} />}
        //@ts-expect-error
        marginBottom="medium"
        onClick={() => manageAgencyEnabledStatus()}
        size="medium"
      >
        {isActive ? 'Disable' : 'Enable'} Agency
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faBorderOuter} />}
        //@ts-expect-error
        marginBottom="medium"
        onClick={() => copyAgencyData()}
        size="medium"
      >
        Copy Agency Data
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faBorderOuter} />}
        //@ts-expect-error
        marginBottom="medium"
        onClick={() => manageAgencyTemplates()}
        size="medium"
      >
        Assign Templates
      </Button>

      {isMasterAdmin && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faLock} />}
          onClick={() => confirmLock({ toggleAgencyLock, toggleFn })}
          size="medium"
        >
          Lock Agency
        </Button>
      )}

      {isMasterAdmin && (
        <Button
          buttonStyle="secondaryUtility"
          loading={loading}
          icon={<FontAwesomeIcon icon={faFileExport} />}
          //@ts-expect-error
          marginTop="medium"
          onClick={() => exportAgency(exportAgencyPayload)}
          size="medium"
        >
          Export Agency
        </Button>
      )}
    </Tools>
  )
}

export default AgencyTools
